export const ONE_DAY_IN_MS = 1000 * 60 * 60 * 24;
